import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Landing from './pages/Landing';
import CGU from './pages/CGU';
import MentionsLegales from './pages/MentionsLegales';
import Confidentialite from './pages/Confidentialite';

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/"                  element={<Landing />} />
        <Route path="/cgu"               element={<CGU />} />
        <Route path="/mentions-legales"  element={<MentionsLegales />} />
        <Route path="/confidentialite"   element={<Confidentialite />} />
        <Route path="*"                  element={<Landing />} />
      </Routes>
    </BrowserRouter>
  );
}
